import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

export function UnknownStatusCard() {
  return (
    <BaseReferralStatusCard
      intent="neutral"
      illustration="person-destructive"
      title="We could not fetch your referral status at this time"
    />
  );
}
